import { create } from 'zustand';
import {LOCATION_NAME_TO_ID} from "../utils/constants";
import {isPrivileged} from "../utils/permissions";

const useUserStore = create((set, get) => ({
    currentUser: null,
    privileged: false,
    permissions: new Set(),

    setCurrentUser: (user) => set({
        currentUser: user ,
        privileged: isPrivileged(user)
    }),

    setPermissions: (permissionsArray) => set({
        permissions: new Set(permissionsArray),
        privileged: permissionsArray.length > 0,
    }),
    isUserAuthenticated: () => get().currentUser?.authenticated === true,

    employees: [],
    setEmployees: (employees) => set({ employees: Array.isArray(employees) ? employees : [] }),

    employeeEvents: {},

    setEmployeeEvents: (user_id, update) => {
        set((state) => {
            const prev = Array.isArray(state.employeeEvents[user_id])
                ? state.employeeEvents[user_id]
                : [];

            const newList = typeof update === 'function'
                ? update(prev)
                : update;

            if (!Array.isArray(newList)) {
                console.warn("setEmployeeEvents called with non-array:", newList);
                return {
                    employeeEvents: {
                        ...state.employeeEvents,
                        [user_id]: []
                    }
                };
            }

            return {
                employeeEvents: {
                    ...state.employeeEvents,
                    [user_id]: newList
                }
            };
        });
    },


    requestList: [],
    setRequestList: (update) => {
        set((state) => {
            const newList = typeof update === 'function'
                ? update(state.requestList)
                : update;

            if (!Array.isArray(newList)) {
                console.warn("setRequestList called with non-array:", newList);
                return { requestList: [] };
            }

            return { requestList: newList };
        });
    },

    selectedLocation: LOCATION_NAME_TO_ID.UNSELECTED,
    setSelectedLocation: (location) => set({ selectedLocation: location }),

    // Long-running work (payroll run) should not log the user out if they
    // switch tabs and stop generating mouse events.
    keepAwakeCount: 0,
    beginKeepAwake: () => set((state) => ({ keepAwakeCount: state.keepAwakeCount + 1 })),
    endKeepAwake: () => set((state) => ({ keepAwakeCount: Math.max(0, state.keepAwakeCount - 1) })),

    userIdToFirstName: {
        "104": "Anna",
        "105": "Shelly",
        "114": "Emilee",
        "115": "Kelly",
        "117": "Kieley",
        "119": "Katie",
        "123": "Maly",
        "124": "Tifani",
        "125": "Cloe",
        "126": "Malcolm",
        "127": "Payton",
        "128": "Roxanne",
        "129": "Haley",
        "153": "Josh",
        "130": "Kenzie"
    },

    setUserIdToFirstName: (firstNameMap) => set({ userIdToFirstName: firstNameMap }),

}));

export default useUserStore;

/**
 * Gets the employee domain objects, but not their timeclock event lists.
 * @returns {Promise<void>}
 */
export async function fetchAndSetEmployees(emps) {
    const { setEmployees, setUserIdToFirstName } = useUserStore.getState();

    try {
        setEmployees(emps);

        const idToNameMap = emps.reduce((map, employee) => {
            map[parseInt(employee.user_id, 10)] = employee.first_name;
            return map;
        }, {});

        setUserIdToFirstName(idToNameMap);
    } catch (error) {
        const errorMessage =
            error?.response?.data?.details ||
            error?.response?.data?.error ||
            error?.message ||
            "Unknown error occurred";
        console.error("Error fetching employees with statuses:", errorMessage);
        alert(`Error fetching employees with statuses: ${errorMessage}`);
    }
}